/* tslint:disable */
/* auto-generated angular directive proxies */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone } from '@angular/core';

import { ProxyCmp, proxyOutputs } from './angular-component-lib/utils';

import type { Components } from '@jump-tech-frontend/core-components/components';

import { defineCustomElement as defineJuiAlertBlock } from '@jump-tech-frontend/core-components/components/jui-alert-block.js';
import { defineCustomElement as defineJuiBadge } from '@jump-tech-frontend/core-components/components/jui-badge.js';
import { defineCustomElement as defineJuiButton } from '@jump-tech-frontend/core-components/components/jui-button.js';
import { defineCustomElement as defineJuiCard } from '@jump-tech-frontend/core-components/components/jui-card.js';
import { defineCustomElement as defineJuiCheckbox } from '@jump-tech-frontend/core-components/components/jui-checkbox.js';
import { defineCustomElement as defineJuiCheckboxGroup } from '@jump-tech-frontend/core-components/components/jui-checkbox-group.js';
import { defineCustomElement as defineJuiChip } from '@jump-tech-frontend/core-components/components/jui-chip.js';
import { defineCustomElement as defineJuiChipset } from '@jump-tech-frontend/core-components/components/jui-chipset.js';
import { defineCustomElement as defineJuiFileInput } from '@jump-tech-frontend/core-components/components/jui-file-input.js';
import { defineCustomElement as defineJuiIcon } from '@jump-tech-frontend/core-components/components/jui-icon.js';
import { defineCustomElement as defineJuiImageCapture } from '@jump-tech-frontend/core-components/components/jui-image-capture.js';
import { defineCustomElement as defineJuiInput } from '@jump-tech-frontend/core-components/components/jui-input.js';
import { defineCustomElement as defineJuiLikert } from '@jump-tech-frontend/core-components/components/jui-likert.js';
import { defineCustomElement as defineJuiNumberInput } from '@jump-tech-frontend/core-components/components/jui-number-input.js';
import { defineCustomElement as defineJuiProgressStepper } from '@jump-tech-frontend/core-components/components/jui-progress-stepper.js';
import { defineCustomElement as defineJuiQrCode } from '@jump-tech-frontend/core-components/components/jui-qr-code.js';
import { defineCustomElement as defineJuiRadio } from '@jump-tech-frontend/core-components/components/jui-radio.js';
import { defineCustomElement as defineJuiRadioGroup } from '@jump-tech-frontend/core-components/components/jui-radio-group.js';
import { defineCustomElement as defineJuiSelect } from '@jump-tech-frontend/core-components/components/jui-select.js';
import { defineCustomElement as defineJuiSkeletonLoader } from '@jump-tech-frontend/core-components/components/jui-skeleton-loader.js';
import { defineCustomElement as defineJuiSvgIcon } from '@jump-tech-frontend/core-components/components/jui-svg-icon.js';
import { defineCustomElement as defineJuiTextarea } from '@jump-tech-frontend/core-components/components/jui-textarea.js';
import { defineCustomElement as defineJuiTooltip } from '@jump-tech-frontend/core-components/components/jui-tooltip.js';
@ProxyCmp({
  defineCustomElementFn: defineJuiAlertBlock,
  inputs: ['animated', 'clearAfterMs', 'clearable', 'color', 'iconName', 'marginSize', 'size', 'titleText']
})
@Component({
  selector: 'jui-alert-block',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['animated', 'clearAfterMs', 'clearable', 'color', 'iconName', 'marginSize', 'size', 'titleText'],
  standalone: true
})
export class JuiAlertBlock {
  protected el: HTMLJuiAlertBlockElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['juiDismiss']);
  }
}


import type { DismissDetails as IJuiAlertBlockDismissDetails } from '@jump-tech-frontend/core-components/components';

export declare interface JuiAlertBlock extends Components.JuiAlertBlock {

  juiDismiss: EventEmitter<CustomEvent<IJuiAlertBlockDismissDetails>>;
}


@ProxyCmp({
  defineCustomElementFn: defineJuiBadge,
  inputs: ['announce', 'color', 'outlined', 'position', 'pulse', 'size', 'type']
})
@Component({
  selector: 'jui-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['announce', 'color', 'outlined', 'position', 'pulse', 'size', 'type'],
  standalone: true
})
export class JuiBadge {
  protected el: HTMLJuiBadgeElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface JuiBadge extends Components.JuiBadge {}


@ProxyCmp({
  defineCustomElementFn: defineJuiButton,
  inputs: ['color', 'cursor', 'disableUserSelect', 'disabled', 'display', 'expand', 'icon', 'loading', 'size', 'titleText', 'type']
})
@Component({
  selector: 'jui-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['color', 'cursor', 'disableUserSelect', 'disabled', 'display', 'expand', 'icon', 'loading', 'size', 'titleText', 'type'],
  standalone: true
})
export class JuiButton {
  protected el: HTMLJuiButtonElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface JuiButton extends Components.JuiButton {}


@ProxyCmp({
  defineCustomElementFn: defineJuiCard,
  inputs: ['borderless', 'elevated', 'highlight', 'hug', 'inverse', 'size', 'squared', 'zoom']
})
@Component({
  selector: 'jui-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['borderless', 'elevated', 'highlight', 'hug', 'inverse', 'size', 'squared', 'zoom'],
  standalone: true
})
export class JuiCard {
  protected el: HTMLJuiCardElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface JuiCard extends Components.JuiCard {}


@ProxyCmp({
  defineCustomElementFn: defineJuiCheckbox,
  inputs: ['checked', 'disable', 'emiteventonload', 'label', 'name', 'single', 'size', 'toggle', 'toggleofftext', 'toggleontext', 'value']
})
@Component({
  selector: 'jui-checkbox',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['checked', 'disable', 'emiteventonload', 'label', 'name', 'single', 'size', 'toggle', 'toggleofftext', 'toggleontext', 'value'],
  standalone: true
})
export class JuiCheckbox {
  protected el: HTMLJuiCheckboxElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['juiChecked', 'juiCheckboxChecked']);
  }
}


export declare interface JuiCheckbox extends Components.JuiCheckbox {

  juiChecked: EventEmitter<CustomEvent<boolean>>;

  juiCheckboxChecked: EventEmitter<CustomEvent<{ value: string; checked: boolean }>>;
}


@ProxyCmp({
  defineCustomElementFn: defineJuiCheckboxGroup,
  inputs: ['dataqastring', 'disable', 'display', 'errors', 'help', 'label', 'messages', 'name', 'required', 'size', 'storybook', 'tooltip', 'validation', 'value']
})
@Component({
  selector: 'jui-checkbox-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['dataqastring', 'disable', 'display', 'errors', 'help', 'label', 'messages', 'name', 'required', 'size', 'storybook', 'tooltip', 'validation', 'value'],
  standalone: true
})
export class JuiCheckboxGroup {
  protected el: HTMLJuiCheckboxGroupElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['juiChange']);
  }
}


export declare interface JuiCheckboxGroup extends Components.JuiCheckboxGroup {

  juiChange: EventEmitter<CustomEvent<number | string>>;
}


@ProxyCmp({
  defineCustomElementFn: defineJuiChip,
  inputs: ['color', 'dataqastring', 'disable', 'icon', 'isRadio', 'isSelected', 'pill', 'removable', 'selectable', 'single', 'size', 'value'],
  methods: ['setChipTabIndex', 'setFocused']
})
@Component({
  selector: 'jui-chip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['color', 'dataqastring', 'disable', 'icon', 'isRadio', 'isSelected', 'pill', 'removable', 'selectable', 'single', 'size', 'value'],
  standalone: true
})
export class JuiChip {
  protected el: HTMLJuiChipElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['juiChipChecked', 'juiChecked', 'juiChipRemoved']);
  }
}


export declare interface JuiChip extends Components.JuiChip {

  juiChipChecked: EventEmitter<CustomEvent<{ value: string; checked: boolean }>>;

  juiChecked: EventEmitter<CustomEvent<{ value: string; checked: boolean }>>;

  juiChipRemoved: EventEmitter<CustomEvent<{ value: string; checked: boolean }>>;
}


@ProxyCmp({
  defineCustomElementFn: defineJuiChipset,
  inputs: ['color', 'dataqastring', 'disable', 'errors', 'grow', 'help', 'icon', 'items', 'label', 'messages', 'name', 'pill', 'required', 'size', 'tooltip', 'type', 'validation', 'value', 'vertical'],
  methods: ['syncWithFormValue']
})
@Component({
  selector: 'jui-chipset',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['color', 'dataqastring', 'disable', 'errors', 'grow', 'help', 'icon', 'items', 'label', 'messages', 'name', 'pill', 'required', 'size', 'tooltip', 'type', 'validation', 'value', 'vertical'],
  standalone: true
})
export class JuiChipset {
  protected el: HTMLJuiChipsetElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['juiChange', 'juiFocus', 'juiBlur']);
  }
}


export declare interface JuiChipset extends Components.JuiChipset {
  /**
   * Output event emitted when change is fired
   */
  juiChange: EventEmitter<CustomEvent<string>>;
  /**
   * Output event emitted when focus is fired
   */
  juiFocus: EventEmitter<CustomEvent<string>>;
  /**
   * Output event emitted when blur is fired
   */
  juiBlur: EventEmitter<CustomEvent<string>>;
}


@ProxyCmp({
  defineCustomElementFn: defineJuiFileInput,
  inputs: ['accept', 'actionlabel', 'dataqastring', 'disable', 'errors', 'files', 'help', 'label', 'maxfilesize', 'maxuploads', 'messages', 'mobile', 'multiple', 'name', 'readonly', 'required', 'size', 'smallbadge', 'tooltip', 'validation']
})
@Component({
  selector: 'jui-file-input',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['accept', 'actionlabel', 'dataqastring', 'disable', 'errors', 'files', 'help', 'label', 'maxfilesize', 'maxuploads', 'messages', 'mobile', 'multiple', 'name', 'readonly', 'required', 'size', 'smallbadge', 'tooltip', 'validation'],
  standalone: true
})
export class JuiFileInput {
  protected el: HTMLJuiFileInputElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['juiChange']);
  }
}


export declare interface JuiFileInput extends Components.JuiFileInput {
  /**
   * Output event emitted when change is fired
   */
  juiChange: EventEmitter<CustomEvent<File[] | null>>;
}


@ProxyCmp({
  defineCustomElementFn: defineJuiIcon,
  inputs: ['color', 'cursor', 'disabled', 'isButton', 'name', 'size', 'titleText', 'type']
})
@Component({
  selector: 'jui-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['color', 'cursor', 'disabled', 'isButton', 'name', 'size', 'titleText', 'type'],
  standalone: true
})
export class JuiIcon {
  protected el: HTMLJuiIconElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface JuiIcon extends Components.JuiIcon {}


@ProxyCmp({
  defineCustomElementFn: defineJuiImageCapture,
  inputs: ['accept', 'actionlabel', 'capture', 'dataqastring', 'disabled', 'images', 'inputid', 'label', 'maxedge', 'maxfilesize', 'maximages', 'quality', 'readonly', 'sort'],
  methods: ['addImages', 'openPicker']
})
@Component({
  selector: 'jui-image-capture',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['accept', 'actionlabel', 'capture', 'dataqastring', 'disabled', 'images', 'inputid', 'label', 'maxedge', 'maxfilesize', 'maximages', 'quality', 'readonly', 'sort'],
  standalone: true
})
export class JuiImageCapture {
  protected el: HTMLJuiImageCaptureElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['juiImagesChange', 'juiReject', 'juiCaptureRequest', 'juiImageClick']);
  }
}


import type { JuiImageEntry as IJuiImageCaptureJuiImageEntry } from '@jump-tech-frontend/core-components/components';
import type { JuiImageRejection as IJuiImageCaptureJuiImageRejection } from '@jump-tech-frontend/core-components/components';
import type { JuiImageClick as IJuiImageCaptureJuiImageClick } from '@jump-tech-frontend/core-components/components';

export declare interface JuiImageCapture extends Components.JuiImageCapture {
  /**
   * Emitted with the full image list after any capture or removal.
   */
  juiImagesChange: EventEmitter<CustomEvent<IJuiImageCaptureJuiImageEntry[]>>;
  /**
   * Emitted for each file or image the control refuses, separately from any validation.
   */
  juiReject: EventEmitter<CustomEvent<IJuiImageCaptureJuiImageRejection>>;
  /**
   * Emitted when the capture button is pressed, before the picker opens. Cancel it to supply
the image another way, then call `addImages` or `openPicker`.
   */
  juiCaptureRequest: EventEmitter<CustomEvent<void>>;
  /**
   * Emitted when an image is clicked or, in read-only mode, activated from the keyboard.
   */
  juiImageClick: EventEmitter<CustomEvent<IJuiImageCaptureJuiImageClick>>;
}


@ProxyCmp({
  defineCustomElementFn: defineJuiInput,
  inputs: ['autofocus', 'clearable', 'dataqastring', 'disable', 'errors', 'help', 'icon', 'label', 'maxlength', 'messages', 'minlength', 'name', 'placeholder', 'readonly', 'required', 'size', 'tooltip', 'transitional', 'type', 'validation', 'value'],
  methods: ['getSelectionRange']
})
@Component({
  selector: 'jui-input',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['autofocus', 'clearable', 'dataqastring', 'disable', 'errors', 'help', 'icon', 'label', 'maxlength', 'messages', 'minlength', 'name', 'placeholder', 'readonly', 'required', 'size', 'tooltip', 'transitional', 'type', 'validation', 'value'],
  standalone: true
})
export class JuiInput {
  protected el: HTMLJuiInputElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['juiChange', 'juiInput', 'juiBlur', 'juiFocus']);
  }
}


export declare interface JuiInput extends Components.JuiInput {
  /**
   * Output event emitted when change is fired
   */
  juiChange: EventEmitter<CustomEvent<string>>;
  /**
   * Output event emitted when input is fired
   */
  juiInput: EventEmitter<CustomEvent<string>>;
  /**
   * Output event emitted when blur is fired
   */
  juiBlur: EventEmitter<CustomEvent<string>>;
  /**
   * Output event emitted when focus is fired
   */
  juiFocus: EventEmitter<CustomEvent<string>>;
}


@ProxyCmp({
  defineCustomElementFn: defineJuiLikert,
  inputs: ['color', 'dataqastring', 'disabled', 'maxvalue', 'minvalue', 'readonly', 'sb', 'size', 'type', 'value']
})
@Component({
  selector: 'jui-likert',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['color', 'dataqastring', 'disabled', 'maxvalue', 'minvalue', 'readonly', 'sb', 'size', 'type', 'value'],
  standalone: true
})
export class JuiLikert {
  protected el: HTMLJuiLikertElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['valueChange']);
  }
}


import type { LikertValue as IJuiLikertLikertValue } from '@jump-tech-frontend/core-components/components';

export declare interface JuiLikert extends Components.JuiLikert {

  valueChange: EventEmitter<CustomEvent<IJuiLikertLikertValue>>;
}


@ProxyCmp({
  defineCustomElementFn: defineJuiNumberInput,
  inputs: ['align', 'autofocus', 'clearable', 'currency', 'dataqastring', 'disable', 'errors', 'format', 'help', 'icon', 'label', 'locale', 'max', 'messages', 'min', 'name', 'numstyle', 'placeholder', 'precision', 'readonly', 'required', 'showsteps', 'size', 'step', 'tooltip', 'transitional', 'validation', 'value']
})
@Component({
  selector: 'jui-number-input',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['align', 'autofocus', 'clearable', 'currency', 'dataqastring', 'disable', 'errors', 'format', 'help', 'icon', 'label', 'locale', 'max', 'messages', 'min', 'name', 'numstyle', 'placeholder', 'precision', 'readonly', 'required', 'showsteps', 'size', 'step', 'tooltip', 'transitional', 'validation', 'value'],
  standalone: true
})
export class JuiNumberInput {
  protected el: HTMLJuiNumberInputElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['juiChange', 'juiInput', 'juiBlur', 'juiFocus']);
  }
}


export declare interface JuiNumberInput extends Components.JuiNumberInput {
  /**
   * Output event emitted when change is fired
   */
  juiChange: EventEmitter<CustomEvent<number | string>>;
  /**
   * Output event emitted when input is fired
   */
  juiInput: EventEmitter<CustomEvent<number | string>>;
  /**
   * Output event emitted when blur is fired
   */
  juiBlur: EventEmitter<CustomEvent<number | string>>;
  /**
   * Output event emitted when blur is fired
   */
  juiFocus: EventEmitter<CustomEvent<number | string>>;
}


@ProxyCmp({
  defineCustomElementFn: defineJuiProgressStepper,
  inputs: ['color', 'size', 'step', 'total']
})
@Component({
  selector: 'jui-progress-stepper',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['color', 'size', 'step', 'total'],
  standalone: true
})
export class JuiProgressStepper {
  protected el: HTMLJuiProgressStepperElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface JuiProgressStepper extends Components.JuiProgressStepper {}


@ProxyCmp({
  defineCustomElementFn: defineJuiQrCode,
  inputs: ['color', 'contents', 'squares']
})
@Component({
  selector: 'jui-qr-code',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['color', 'contents', 'squares'],
  standalone: true
})
export class JuiQrCode {
  protected el: HTMLJuiQrCodeElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface JuiQrCode extends Components.JuiQrCode {}


@ProxyCmp({
  defineCustomElementFn: defineJuiRadio,
  inputs: ['checked', 'disable', 'label', 'name', 'size', 'value'],
  methods: ['setButtonTabindex', 'setFocused']
})
@Component({
  selector: 'jui-radio',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['checked', 'disable', 'label', 'name', 'size', 'value'],
  standalone: true
})
export class JuiRadio {
  protected el: HTMLJuiRadioElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['juiChecked']);
  }
}


export declare interface JuiRadio extends Components.JuiRadio {

  juiChecked: EventEmitter<CustomEvent<string>>;
}


@ProxyCmp({
  defineCustomElementFn: defineJuiRadioGroup,
  inputs: ['dataqastring', 'disable', 'display', 'errors', 'help', 'label', 'messages', 'name', 'required', 'size', 'storybook', 'tooltip', 'validation', 'value']
})
@Component({
  selector: 'jui-radio-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['dataqastring', 'disable', 'display', 'errors', 'help', 'label', 'messages', 'name', 'required', 'size', 'storybook', 'tooltip', 'validation', 'value'],
  standalone: true
})
export class JuiRadioGroup {
  protected el: HTMLJuiRadioGroupElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['juiChange']);
  }
}


export declare interface JuiRadioGroup extends Components.JuiRadioGroup {

  juiChange: EventEmitter<CustomEvent<number | string>>;
}


@ProxyCmp({
  defineCustomElementFn: defineJuiSelect,
  inputs: ['addtag', 'autofocus', 'bindlabel', 'bindvalue', 'clearable', 'dataqastring', 'disable', 'errors', 'help', 'hideselected', 'highlight', 'inlinelabel', 'items', 'label', 'loading', 'maxselectedchips', 'messages', 'minsearchterm', 'multiple', 'name', 'optionstemplate', 'order', 'placeholder', 'readonly', 'required', 'sb', 'sbitems', 'sboptionstemplate', 'selectallenabled', 'size', 'tooltip', 'typeahead', 'validation', 'value'],
  methods: ['setValueFromForm']
})
@Component({
  selector: 'jui-select',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['addtag', 'autofocus', 'bindlabel', 'bindvalue', 'clearable', 'dataqastring', 'disable', 'errors', 'help', 'hideselected', 'highlight', 'inlinelabel', 'items', 'label', 'loading', 'maxselectedchips', 'messages', 'minsearchterm', 'multiple', 'name', 'optionstemplate', 'order', 'placeholder', 'readonly', 'required', 'sb', 'sbitems', 'sboptionstemplate', 'selectallenabled', 'size', 'tooltip', 'typeahead', 'validation', 'value'],
  standalone: true
})
export class JuiSelect {
  protected el: HTMLJuiSelectElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['juiChange', 'juiFocus', 'juiBlur', 'juiItemSelected', 'juiItemUnselected', 'juiSelectOpened', 'juiTagAdded']);
  }
}


export declare interface JuiSelect extends Components.JuiSelect {
  /**
   * Output event emitted when change is fired
   */
  juiChange: EventEmitter<CustomEvent<any>>;
  /**
   * Output event emitted when focus is fired
   */
  juiFocus: EventEmitter<CustomEvent<string>>;
  /**
   * Output event emitted when blur is fired
   */
  juiBlur: EventEmitter<CustomEvent<string>>;
  /**
   * Output event emitted when option is selected
   */
  juiItemSelected: EventEmitter<CustomEvent<any>>;
  /**
   * Output event emitted when option is unselected
   */
  juiItemUnselected: EventEmitter<CustomEvent<any>>;
  /**
   * Output event emitted when option is unselected
   */
  juiSelectOpened: EventEmitter<CustomEvent<string>>;
  /**
   * Output event emitted when new tag is added
   */
  juiTagAdded: EventEmitter<CustomEvent<any>>;
}


@ProxyCmp({
  defineCustomElementFn: defineJuiSkeletonLoader,
  inputs: ['color', 'count', 'glass', 'height', 'inline', 'random', 'standalone', 'type', 'width']
})
@Component({
  selector: 'jui-skeleton-loader',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['color', 'count', 'glass', 'height', 'inline', 'random', 'standalone', 'type', 'width'],
  standalone: true
})
export class JuiSkeletonLoader {
  protected el: HTMLJuiSkeletonLoaderElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface JuiSkeletonLoader extends Components.JuiSkeletonLoader {}


@ProxyCmp({
  defineCustomElementFn: defineJuiSvgIcon,
  inputs: ['name', 'size']
})
@Component({
  selector: 'jui-svg-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['name', 'size'],
  standalone: true
})
export class JuiSvgIcon {
  protected el: HTMLJuiSvgIconElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface JuiSvgIcon extends Components.JuiSvgIcon {}


@ProxyCmp({
  defineCustomElementFn: defineJuiTextarea,
  inputs: ['autofocus', 'dataqastring', 'disable', 'errors', 'help', 'label', 'maxlength', 'messages', 'minlength', 'name', 'placeholder', 'readonly', 'required', 'resize', 'rows', 'size', 'tooltip', 'transitional', 'validation', 'value']
})
@Component({
  selector: 'jui-textarea',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['autofocus', 'dataqastring', 'disable', 'errors', 'help', 'label', 'maxlength', 'messages', 'minlength', 'name', 'placeholder', 'readonly', 'required', 'resize', 'rows', 'size', 'tooltip', 'transitional', 'validation', 'value'],
  standalone: true
})
export class JuiTextarea {
  protected el: HTMLJuiTextareaElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['juiChange', 'juiInput', 'juiBlur', 'juiFocus']);
  }
}


export declare interface JuiTextarea extends Components.JuiTextarea {
  /**
   * Output event emitted when change is fired
   */
  juiChange: EventEmitter<CustomEvent<string>>;
  /**
   * Output event emitted when input is fired
   */
  juiInput: EventEmitter<CustomEvent<string>>;
  /**
   * Output event emitted when blur is fired
   */
  juiBlur: EventEmitter<CustomEvent<string>>;
  /**
   * Output event emitted when focus is fired
   */
  juiFocus: EventEmitter<CustomEvent<string>>;
}


@ProxyCmp({
  defineCustomElementFn: defineJuiTooltip,
  inputs: ['dataId']
})
@Component({
  selector: 'jui-tooltip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['dataId'],
  standalone: true
})
export class JuiTooltip {
  protected el: HTMLJuiTooltipElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface JuiTooltip extends Components.JuiTooltip {}


